import { AccountingL2ByAccount } from './AccountingL2ByAccount';
import { shadeColor } from 'utils/util';
export function AccountingL1ByPaymentCompany(props) {
    // payout entries group by payment company
    const {
        payouts,
        accountId2accountName,
        accountId2Investors,
        isTop,
        transactionId2Status,
        timezoneOffset,
        handleStatusChange,
        accountId2Currency,
        companyBgBase,
    } = props;
    const uniqueAccountIds = [
        ...new Set(payouts.map((e) => e.account_id)),
    ].sort();
    return (
        <>
            {payouts.length > 0 && (
                <div
                    style={{
                        display: 'flex',
                        width: 'fit-content',
                        // borderTop: isTop ? '' : '1px solid black',
                    }}
                >
                    <div
                        style={{
                            width: '150px',
                            textAlign: 'center',
                            background: companyBgBase,
                        }}
                    >
                        {payouts[0].payment_company_name}
                    </div>

                    <div>
                        {uniqueAccountIds.map((accountId, idx) => {
                            return (
                                <AccountingL2ByAccount
                                    accountBgColor={
                                        idx % 2 === 0
                                            ? companyBgBase
                                            : shadeColor(companyBgBase, -5)
                                    }
                                    payouts={payouts.filter(
                                        (payout) =>
                                            payout.account_id === accountId
                                    )}
                                    accountId2accountName={
                                        accountId2accountName
                                    }
                                    accountId={accountId}
                                    key={idx}
                                    accountId2Investors={accountId2Investors}
                                    // very first row of the section with the same company
                                    isTop={idx === 0}
                                    transactionId2Status={transactionId2Status}
                                    timezoneOffset={timezoneOffset}
                                    handleStatusChange={handleStatusChange}
                                    accountId2Currency={accountId2Currency}
                                />
                            );
                        })}
                    </div>
                </div>
            )}
        </>
    );
}
